import { ServiceFetch } from '../service-fetch'

export default class ProductSubImageModel extends ServiceFetch {
    getProductSubImageByProductCode = (data) => this.authFetch({
            url: 'product-sub-image/getProductSubImageByProductCode',
            method: 'POST',
            body: JSON.stringify(data),
        })
    }
